import { IBank } from '../../repositories/mortgage-broker-calculator/entities/bank/Bank';

export const mapBanksToOptions = (banks: IBank[]) => {
  const availableBanks = banks.map(({ id, title }) => ({ value: id.toString(), label: title }));

  return [{ label: 'Нет зарплатного проекта', value: '0' }, ...availableBanks, { label: 'Другой банк', value: '-1' }];
};
